import { PropDTO } from '@practium/features/parcelling';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { CreatePropertyPayload } from '../../types';
import api from '../../http';
import { useForBindingId } from '../../../forBinding';
import { getApiErrorMessage, toApiError } from '../utils';
import { createFormData } from '../helpers/createFormdata';

export function usePostProperty() {
	const queryClient = useQueryClient();
	const forBinding = useForBindingId();
	return useMutation<PropDTO, Error, CreatePropertyPayload>({
		mutationFn: async (data) => {
			try {
				const formData = createFormData({ ...data, file: data.avatar });
				const response = await api.post<PropDTO>('/user/prop/create', formData, {
					params: { forBinding },
				});
				return response.data;
			} catch (error) {
				throw toApiError(error, 'Erro ao criar propriedade');
			}
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['properties'] });
			queryClient.invalidateQueries({ queryKey: ['areas'] });
		},
		onError: (error) => {
			console.error(
				'Erro ao criar propriedade:',
				getApiErrorMessage(error, 'Erro ao criar propriedade')
			);
		},
	});
}
